import React, { useCallback, useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { tr } from "date-fns/locale";
import { ApiService } from "../services/http.service";
import { format } from "date-fns";
import { isMobile } from "../App";
import camera from "../assets/icons/camera.png";
import play from "../assets/icons/play-button.png";

import { dateForRequest, formatMilliseconds, handleOpenDetails, useForceUpdate } from "../services/misc.functions";
import WayType from "../components/shared/way_type/way_type";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
  dailyBulletin,
  results,
  shownRun,
  shownRunSubject,
  statisticsOptions,
  statisticsOptionsSubject,
} from "../stores/statistics.store";
import _ from "lodash";
import Modal, { modalServiceSubject } from "../components/shared/modal/Modal";

registerLocale("tr", tr);

export const PreviousWins: React.FC<any> = () => {
  const [runData, setRunData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const forceUpdate = useForceUpdate();

  const fetchData = useCallback(
    (date: Date) => {
      setLoading(true);
      const api = new ApiService();

      api
        .start("post", "https://tjk-statistics.bitrelic.io/api/previous-wins/", {
          date: dateForRequest(date),
        })
        .then((response: any) => {
          results.length = 0;
          results.push(...response.data);

          const selectedRun = response.data.find(
            (item: any) => item.hippodrome_key === shownRun.hippodrome_key && item.run_no === shownRun.run_no
          );

          if (selectedRun) {
            setRunData(selectedRun);
          }
        })
        .catch((error: any) => {
          console.error("Failed to fetch data", error);
        })
        .finally(() => {
          setLoading(false);
          forceUpdate();
        });
    },
    [shownRun]
  );

  useEffect(() => {
    const statisticsSub = statisticsOptionsSubject.subscribe(() => {
      fetchData(statisticsOptions.date);
    });

    const shownRunSub = shownRunSubject.subscribe(() => {
      const selectedRun = results.find(
        (item: any) => item.hippodrome_key === shownRun.hippodrome_key && item.run_no === shownRun.run_no
      );
      if (selectedRun) {
        setRunData(selectedRun);
      }
      forceUpdate();
    });

    fetchData(statisticsOptions.date);

    return () => {
      statisticsSub.unsubscribe();
      shownRunSub.unsubscribe();
    };
  }, [fetchData, statisticsOptions.date]);

  const [visibleRunners, setVisibleRunners] = useState<{ [key: string]: boolean }>({});
  const toggleRunnersVisibility = (horseName: string) => {
    setVisibleRunners((prev) => ({
      ...prev,
      [horseName]: !prev[horseName],
    }));
  };

  return (
    <div className="pt-0">
      <div>
        {loading ? (
          <div className="text-center p-1">
            <div id="id_loaderAnimation" className="loader"></div>
          </div>
        ) : (
          <>
            {!isMobile ? (
              <div className="table-responsive m-2">
                <table className="table table-borderless">
                  {_.sortBy(runData.runners_data, "horse_no").map((runner: any, keyHorse: number) => {
                    const currentDetail = dailyBulletin
                      .find((item: any) => item.keyword === statisticsOptions.selectedHippodrome.tjk_key)
                      ?.runs?.find((run: any) => run.no == shownRun.run_no)
                      ?.horses?.find((horse: any) => horse.no == runner.horse_no);

                    return (
                      <tbody key={`DataTable-runners-${keyHorse}`}>
                        <tr style={{ cursor: "pointer", backgroundColor: "#9CA0E9" }}>
                          <td
                            colSpan={3}
                            style={{
                              color: "#fff",
                              fontWeight: "bold",
                              borderTopLeftRadius: "5px",
                            }}
                          >
                            {runner.horse_no} - {runner.horse_name}
                          </td>

                          <td
                            colSpan={4}
                            style={{
                              color: "#253E9E",
                              fontWeight: "bold",
                              borderTopRightRadius: "5px",
                              backgroundColor: "#D7D9F7",
                            }}
                          >
                            <div className="row">
                              <div className="col-4 text-center">{currentDetail?.jokey.short_name}</div>
                              <div className="col-4 text-center">{currentDetail?.weight} KG</div>
                              <div className="col-4 text-center">ST {currentDetail?.start}</div>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ backgroundColor: "#EDEEFB" }}>
                          <td>Tarih</td>
                          <td>Şehir</td>
                          <td>Mesafe</td>
                          <td>Pist</td>
                          <td>Sıra</td>
                          <td>Kilo</td>
                          <td>Jokey</td>
                          <td>Start</td>
                          <td>GNY</td>
                          <td>Grup</td>
                          <td>Şart</td>
                          <td>Derece</td>
                          <td>HP</td>
                          <td>AGF</td>
                          <td className="text-center">FF</td>
                          {/* <td className="text-center" style={{ borderTopRightRadius: "5px" }}>
                            Video
                          </td> */}
                        </tr>

                        {runner.best_degree?.length > 0 ? (
                          runner.best_degree.map((degree: any, index: number) => (
                            <React.Fragment key={`DataTable-degrees-${keyHorse}-${index}`}>
                              <tr
                                className="elevated-row"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleOpenDetails(degree.date, degree.location, shownRun.run_no)}
                              >
                                <td>{format(new Date(degree.date), "dd.MM.yyyy")}</td>
                                <td>{degree.location}</td>
                                <td>{degree.distance}</td>
                                <td>{degree.running_track_name}</td>
                                <td>
                                  {degree.result || degree.start_no}/{degree.runner_count}
                                </td>
                                <td>{degree.weight}</td>
                                <td>{degree.jockey?.name}</td>
                                <td>{degree.start_no}</td>
                                <td>{degree.ganyan}</td>
                                <td>{degree.run_group_short}</td>
                                <td>{degree.run_breed_detail}</td>
                                <td>{formatMilliseconds(degree.degree)}</td>
                                <td>{degree.handicap}</td>
                                <td>%{degree.agf_1}</td>
                                <td
                                  className="text-center"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                  }}
                                >
                                  {degree.photo_finish ? (
                                    <img
                                      src={camera}
                                      alt="FF"
                                      width={15}
                                      height={15}
                                      className="mb-1"
                                      onClick={() => {
                                        modalServiceSubject.next({
                                          content: (
                                            <img
                                              alt="photo_finish"
                                              src={decodeURI(degree.photo_finish)}
                                              style={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                width: "auto",
                                              }}
                                            />
                                          ),
                                          confirm: {
                                            cancel: {
                                              label: "Kapat",
                                            },
                                          },
                                        });
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {/* <td
                                  className="text-center"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                  }}
                                >
                                  {degree.video ? (
                                    <img
                                      src={play}
                                      alt="play"
                                      width={15}
                                      height={15}
                                      className="mb-1"
                                      onClick={() => {
                                        modalServiceSubject.next({
                                          content: (
                                            <video controls autoPlay style={{ width: "100%" }}>
                                              <source src={decodeURI(degree.video)} type="video/mp4" />
                                            </video>
                                          ),

                                          confirm: {
                                            cancel: {
                                              label: "Kapat",
                                            },
                                          },
                                        });
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </td> */}
                              </tr>
                            </React.Fragment>
                          ))
                        ) : (
                          <tr className="elevated-row">
                            <td colSpan={14} className="text-center">
                              Birinciliği Bulunmamaktadır.
                            </td>
                          </tr>
                        )}

                        <tr>
                          <th className="seperator"></th>
                        </tr>
                        <tr>
                          <th className="seperator"></th>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            ) : (
              <div className="mobile-best-degree-table">
                {_.sortBy(runData.runners_data, "horse_no").map((runner: any, keyHorse: number) => {
                  const isVisible = visibleRunners[runner.horse_name] || false;
                  return (
                    <div className="table-item" key={`DataTable-horse-${keyHorse}`}>
                      <div
                        className="row"
                        key={`best-degree-${keyHorse}`}
                        onClick={() => toggleRunnersVisibility(runner.horse_name)}
                      >
                        <div className="col-1 horse-no">{runner.horse_no || "-"}</div>

                        <div className="col-10 horse-info justify-content-center" style={{ maxWidth: "300px" }}>
                          <span className="fw-bold horse-name ms-1" style={{ maxWidth: "300px" }}>
                            {runner.horse_name || "-"}
                          </span>
                        </div>

                        <div className="col-1 d-flex align-items-center justify-content-end">
                          {runner.best_degree.length > 0 ? (
                            isVisible ? (
                              <IoIosArrowUp />
                            ) : (
                              <IoIosArrowDown />
                            )
                          ) : (
                            <div className="row text-nowrap" style={{ fontSize: "10px" }}>
                              Birinciliği Bulunmamaktadır.
                            </div>
                          )}
                        </div>
                      </div>
                      {runner.best_degree.map((degree: any, degreeIndex: number) => (
                        <div
                          className={`row flex-nowrap ${isVisible ? "show" : "hide"} mt-2`}
                          key={`best-degree-${degreeIndex}`}
                          onClick={() => handleOpenDetails(degree.date, degree.location, shownRun.run_no)}
                        >
                          <div className="col-5 horse-info">
                            <span style={{ lineHeight: "18px" }}>
                              {format(new Date(degree.date), "dd.MM.yyyy")} /{" "}
                              <span className="fw-bold">{degree.location.split(" ")[0]}</span>
                              <span> / {degree.run_group_short}</span>
                            </span>
                            <div className="d-flex flex-row text-nowrap flex-nowrap">
                              {degree.distance}m /
                              <div
                                style={{
                                  width: "20px",
                                  height: "10px",
                                  marginInline: "1px",
                                  marginTop: "2px",
                                }}
                              >
                                <WayType type={degree.running_track_name} />
                              </div>
                              / {degree.run_breed_detail}
                            </div>
                          </div>

                          <div className="col-4 runner-info">
                            <span className="fw-bold runner-name">{degree.jockey?.name}</span>
                            <span>
                              {degree.weight}kg / HP: {degree.handicap}
                            </span>
                            <span>
                              GNY: {degree.ganyan} / AGF: {degree.agf_1}
                            </span>
                          </div>

                          <div className="col-2 runner-result">
                            <span className="degree">{formatMilliseconds(degree.degree)}</span>
                            <span>
                              S / <span className="fw-bold">{degree.start_no}</span>
                            </span>
                            <span>
                              F /{" "}
                              <span className="fw-bold">
                                {degree.result || degree.start_no}/{degree.runner_count}
                              </span>
                            </span>
                          </div>

                          <div
                            className="col-1 runner-media"
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                          >
                            {degree.photo_finish && decodeURI(degree.photo_finish).trim() ? (
                              <img
                                src={camera}
                                alt="FF"
                                width={15}
                                height={15}
                                className="mb-1"
                                onClick={() => {
                                  modalServiceSubject.next({
                                    content: (
                                      <img
                                        alt="photo_finish"
                                        src={decodeURI(degree.photo_finish)}
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                          width: "auto",
                                        }}
                                      />
                                    ),
                                    confirm: {
                                      cancel: {
                                        label: "Kapat",
                                      },
                                    },
                                  });
                                }}
                              />
                            ) : (
                              <span>-</span>
                            )}

                            {/* {degree.video && decodeURI(degree.video).trim() ? (
                              <img
                                src={play}
                                alt="play"
                                width={15}
                                height={15}
                                className="mb-1"
                                onClick={() => {
                                  modalServiceSubject.next({
                                    content: (
                                      <video controls autoPlay style={{ width: "100%" }}>
                                        <source src={decodeURI(degree.video)} type="video/mp4" />
                                      </video>
                                    ),

                                    confirm: {
                                      cancel: {
                                        label: "Kapat",
                                      },
                                    },
                                  });
                                }}
                              />
                            ) : (
                              <span>-</span>
                            )} */}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>

      <div className="info">
        <span className="title">Birincilikler</span>
        <span className="description">
          Atların, katıldıkları son resmi yarışlarında aldıkları birincilikleri ifade eder. Sıra numarası, birincilik
          sayısı ve yüzde verilerini içerir.
        </span>
      </div>
    </div>
  );
};
